import type { ConversationDiagnostics } from "@mirage/service-conversation/service/conversationDiagnostics";
import { useEffect, useState } from "react";
import { observeConversationDiagnosticsLogs } from "..";

export function useConversationDiagnostics():
  | ConversationDiagnostics
  | undefined {
  const [diagnostics, setDiagnostics] = useState<
    ConversationDiagnostics | undefined
  >(undefined);

  useEffect(() => {
    const subscription =
      observeConversationDiagnosticsLogs().subscribe(setDiagnostics);
    return () => subscription.unsubscribe();
  }, []);

  return diagnostics;
}
